import React from 'react';
import { TextAction } from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';

// NEW APP TODO – Replace with the appropriate links for your application.
export const EXTERNAL_LINKS = {
  DISCLAIMER: 'https://google.com/disclaimer',
  APPLE_STORE_APP: 'https://apple.com',
  GOOGLE_PLAY_STORE_APP: 'https://google.com',
  // TODO: confirm final URLs with THP Legal (OQ-ONB-04)
  PRIVACY_POLICY: 'https://www.thp.ca/Pages/Privacy.aspx',
  TERMS_OF_SERVICE: 'https://www.thp.ca/Pages/Legaldisclaimer.aspx',
  PERSONAL_INFO: 'https://mychart.thp.ca/mychart/app/personal-information',
  SHARING_YOUR_DATA: 'https://mychart.thp.ca/mychart/app/sharing-hub/',
  SECURITY_PREFERENCES:
    'https://mychart.thp.ca/mychart/app/security-settings?mode=passwd',
};

type PersonalInfoLinkProps = {
  chunks: React.ReactNode;
  typography: '$subtitleOne' | '$subtitleTwo';
};

const PersonalInfoLink = ({ chunks, typography }: PersonalInfoLinkProps) => {
  const { formatMessage } = useIntl();
  return (
    <TextAction
      href={EXTERNAL_LINKS.PERSONAL_INFO}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={formatMessage({ id: 'STR_LINK_TO_MYCHART' })}
      css={{
        '&&': {
          typography,
          textDecoration: 'underline',
        },
      }}
    >
      {chunks}
    </TextAction>
  );
};

export const renderPersonalInfoLink =
  (typography: PersonalInfoLinkProps['typography']) =>
  (chunks: React.ReactNode) =>
    <PersonalInfoLink chunks={chunks} typography={typography} />;

// Placeholder internal routes for footer links until real pages exist.
export const INTERNAL_LINKS = {
  ABOUT: '/about',
  CONTACT_US: '/contact',
  TERMS: '/terms',
  POLICY: '/policy',
  PERSONAL_INFO: '/personal-info',
  COMMUNICATION: '/communication',
};
